import { render, staticRenderFns } from "./CampaignsSkeleton.vue?vue&type=template&id=04309419&scoped=true"
import script from "./CampaignsSkeleton.vue?vue&type=script&lang=js"
export * from "./CampaignsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CampaignsSkeleton.vue?vue&type=style&index=0&id=04309419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04309419",
  null
  
)

export default component.exports